import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './contexts/AuthContext';
import { SelectedCompanyProvider } from './contexts/SelectedCompanyContext';
import { SidebarProvider } from './contexts/SidebarContext';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './Routes';
import { useEffect } from 'react';
import './styles/index.css';
import './styles/react-query-custom.css';

// Configurar React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

function App() {
  // Solicitar permissão para notificações ao carregar
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      setTimeout(() => {
        Notification.requestPermission();
      }, 3000); // Aguarda 3s antes de pedir
    }

    // Service Worker desabilitado temporariamente
    // Para habilitar PWA, descomente o código abaixo:
    /*
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registrado:', registration);
          })
          .catch((error) => {
            console.log('Erro ao registrar SW:', error);
          });
      });
    }
    */
  }, []);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <SelectedCompanyProvider>
              <SidebarProvider>
                <ToastProvider>
                  <Routes />
                </ToastProvider>
              </SidebarProvider>
            </SelectedCompanyProvider>
          </AuthProvider>
        </BrowserRouter>
        
        {/* React Query Devtools - ocultado conforme solicitado */}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
